import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { User_Authentication } from "../../../../user_authentication/User_Authentication"
import { get_astro_wallet_detail, get_astro_wallet_history, Withdrawal_Request } from '../../../../api/astrologer/Astrologer'
import Loader from '../../../../loader/Loader'
import { toast } from "react-toastify";
import { formatInTimeZone } from "date-fns-tz";
import Astrologer_after_Login_Header from "../astrologer_after_login_header/Astrologer_after_Login_Header"
import Astrologer_Footer from "../astrologer_footer/Astrologer_Footer"

const Withdrawal_History = () => {
    const navigate = useNavigate()
    const [is_loading, set_Is_Loading] = useState(false)
    const [get_wallet_details, set_Wallet_Details] = useState({})
    // const [get_wallet_list, set_Wallet_List] = useState([])

    const [currentPage, setCurrentPage] = useState(1);
    const [is_withdrawal, set_Is_Withdrawal] = useState(false)
    const [withdrawal_type, set_Is_Withdrawal_Type] = useState("")
    const [partial_amount, set_Partial_Amount] = useState("")
    const [error, setError] = useState({});
    const [confirmation_popup, set_Confirmation_Popup] = useState(false)

    const productsPerPage = 10;

    // Calculate total pages safely
    const totalPages = Math.ceil(get_wallet_details?.withdraw_history?.length / productsPerPage) || 1;

    // Calculate the products to display on the current page
    const startIndex = (currentPage - 1) * productsPerPage;
    const currentProduct = get_wallet_details?.withdraw_history?.slice(startIndex, startIndex + productsPerPage) || [];

    // Pagination controls
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleNext = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePrev = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handle_cancel_withdrawal = () => {
        set_Confirmation_Popup(true)
    }

    const handle_Keep_withdrawal = () => {
        set_Confirmation_Popup(false)
    }

    const handle_Cancel_withdrawal_request = async () => {
        setError({})
        set_Confirmation_Popup(false)
        set_Is_Withdrawal(false)
        set_Is_Withdrawal_Type("")
        set_Partial_Amount("")
    }

    const handle_Get_Wallet_Details = async () => {
        set_Is_Loading(true)
        try {
            const token = User_Authentication();
            if (!token) {
                toast("User token not found")
                set_Is_Loading(false)
                throw new Error("User token not found");
            }
            const response = await get_astro_wallet_detail({ Authorization: `Bearer ${token}` })
            if (response?.data?.status == "200") {
                set_Wallet_Details(response?.data?.data)
                set_Is_Loading(false)
            }
            else if (response?.response?.data?.status == "500") {
                set_Is_Loading(false)
            }
        }
        catch (error) {
            set_Is_Loading(false)
        }
    }

    useEffect(() => {
        handle_Get_Wallet_Details();
    }, [])

    // useEffect(() => {
    //     const handle_get_wallet_history = async () => {
    //         set_Is_Loading(true)
    //         try {
    //             const token = User_Authentication();
    //             if (!token) {
    //                 toast("User token not found")
    //                 set_Is_Loading(false)
    //                 throw new Error("User token not found");
    //             }
    //             const response = await get_astro_wallet_history({ Authorization: `Bearer ${token}` })
    //             if (response?.data?.status == "200") {
    //                 set_Wallet_List(response?.data?.data)
    //                 set_Is_Loading(false)
    //             }
    //             else if (response?.response?.data?.status == "500") {
    //                 set_Is_Loading(false)
    //             }
    //         }
    //         catch (error) {
    //             set_Is_Loading(false)
    //         }
    //     }
    //     handle_get_wallet_history();
    // }, [])

    // const formatDateTime = (isoString) => {
    //     const date = new Date(isoString);
    //     const dateOptions = {
    //         year: 'numeric',
    //         month: 'short',
    //         day: '2-digit'
    //     };
    //     const timeOptions = {
    //         hour: '2-digit',
    //         minute: '2-digit',
    //         hour12: true
    //     };
    //     const formattedDate = new Intl.DateTimeFormat('en-US', dateOptions).format(date);
    //     const formattedTime = new Intl.DateTimeFormat('en-US', timeOptions).format(date);
    //     return `${formattedDate} | ${formattedTime}`;
    // };
    const formatDate = (dateString) => {

        // const date = new Date(dateString); // Convert ISO string to Date object
        //              const formattedDate = date
        //   .toLocaleString("en-US", {
        //     month: "short",
        //     day: "2-digit",
        //     year: "numeric",
        //     hour: "2-digit",
        //     minute: "2-digit",
        //     hour12: true
        //   })
        //   .replace(",", "");
        return formatInTimeZone(dateString, "UTC", "MMM dd, yyyy | hh:mm a");
    };

    const handle_withdrawal_popup = () => {
        if (get_wallet_details?.total_amount == 0) {
            toast.error("Insufficient balance. Your wallet balance is ₹0")
            return;
        }
        set_Is_Withdrawal(true)
    }
    const handlePartialAmountChange = (e) => {
        setError({})
        const value = (e.target.value);
        if (value >= 1 || e.target.value === "") {
            if (value > get_wallet_details?.total_amount) {
                setError((prev) => ({
                    ...prev,
                    partial_amount: `Insufficient balance. Your wallet balance is ₹${get_wallet_details?.total_amount}`
                }));
                return;
            }
            else if (value < 100 && value !== "") {
                setError((prev) => ({
                    ...prev,
                    partial_amount: "Minimum withdrawal amount is ₹100"
                }));
            }

            set_Partial_Amount(value);
        }
    }

    const handle_withdrawal_request = async () => {
        setError({})
        if (!withdrawal_type) {
            setError((prev) => ({
                ...prev,
                message: "Please select the withdrawal type"
            }));
            return;
        }
        if (withdrawal_type == "partial") {
            if (!partial_amount) {
                setError((prev) => ({
                    ...prev,
                    message: "Please enter a valid Partial Withdrawal Amount"
                }));
                return;
            }
        }

        if (get_wallet_details?.total_amount == 0) {
            setError((prev) => ({
                ...prev,
                message: "Insufficient balance. Your wallet balance is ₹0"
            }));
            return;
        }

        const withdrawal_amount =
            withdrawal_type === "full"
                ? get_wallet_details?.total_amount
                : partial_amount;

        if (withdrawal_amount < 100) {
            setError((prev) => ({
                ...prev,
                message: "Minimum withdrawal amount is ₹100"
            }));
            return;
        }

        if (withdrawal_amount > get_wallet_details?.total_amount) {
            setError((prev) => ({
                ...prev,
                message: `Insufficient balance. Your wallet balance is ₹${get_wallet_details?.total_amount}`
            }));
            return;
        }

        if (!get_wallet_details?.bank_detail) {
            toast.error("🏦 Please add your Bank Details before making a withdrawal")
            navigate("/astrologer-bank-details")
            return;
        }

        const data = {
            wallet_id: get_wallet_details?.id,
            amount: withdrawal_amount
        }
        try {
            const token = User_Authentication();
            if (!token) {
                toast("User token not found")
                set_Is_Loading(false)
                throw new Error("User token not found");
            }
            set_Is_Loading(true)
            const response = await Withdrawal_Request(data, { Authorization: `Bearer ${token}` })
            console.log("response", response);

            if (response?.status == 200) {
                toast.success(response?.data?.message)
                set_Is_Withdrawal(false)
                handle_Get_Wallet_Details();
                handle_Cancel_withdrawal_request();

            }
            if (response?.response?.data?.status == 500) {
                toast.error(response?.response?.data?.message)
            }
        } catch (error) {
            console.error(error)
        } finally {
            set_Is_Loading(false)
        }
    }
    return (
        <div>
            {/*  */}
            <Astrologer_after_Login_Header />
            {/* <-------- ToastContainer ------------> */}
            {
                is_loading ? (
                    <Loader />
                ) : (
                    <div className="bg-[#f8f9fa] pt-20 lg:pt-8 py-8 px-4 sm:px-6 lg:px-8">
                        <div className="max-w-[1240px] mx-auto">
                            <div className="w-full bg-white rounded-2xl shadow-sm border border-gray-100 p-4 sm:p-6 lg:p-8">
                                <div className="w-full">
                                    <div className="item-body w-full">
                                        <div className="welcome-msg w-full mb-6">
                                            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                                                <h1 className="font-bold text-2xl text-gray-800 tracking-tight">Withdrawal History</h1>
                                                <button
                                                    type="button"
                                                    className="w-full sm:w-auto justify-center text-center inline-flex items-center gap-2 px-4 py-2.5 bg-[#9F2225] hover:bg-[#851c1e] text-white text-sm font-semibold rounded-xl shadow-sm hover:shadow transition-all duration-200"
                                                    onClick={handle_withdrawal_popup}
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-up-right-circle-fill" viewBox="0 0 16 16">
                                                        <path d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m5.904 2.803a.5.5 0 1 0 .707.707L9.293 8.825V11.5a.5.5 0 0 0 1 0V7.5a.5.5 0 0 0-.5-.5H6.5a.5.5 0 0 0 0 1h2.675z" />
                                                    </svg>
                                                    Withdrawal
                                                </button>
                                            </div>
                                        </div>

                                        <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 items-stretch mt-3 border-b border-gray-100 pb-6">
                                            {/* Available Balance Card */}
                                            <div className="w-full min-h-[120px] bg-gradient-to-br from-[#9F2225] to-[#c92f33] rounded-2xl p-5 flex items-center gap-5 shadow-sm transition-all duration-300 hover:shadow-md hover:-translate-y-0.5">
                                                <div className="w-14 h-14 rounded-xl bg-white/20 text-white backdrop-blur-md flex justify-center items-center flex-shrink-0">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" className="bi bi-wallet2" viewBox="0 0 16 16">
                                                        <path d="M12.136.326A1.5 1.5 0 0 1 14 1.78V3h.5A1.5 1.5 0 0 1 16 4.5v9a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 13.5v-9a1.5 1.5 0 0 1 1.43-1.493L12.136.326zM5.562 3H13V1.78a.5.5 0 0 0-.621-.484zM1.5 4a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5z" />
                                                    </svg>
                                                </div>
                                                <div>
                                                    <p className="text-sm text-red-100 font-medium tracking-wide">Available Balance</p>
                                                    <span className="text-2xl font-extrabold text-white mt-1 block">₹{get_wallet_details?.total_amount}</span>
                                                </div>
                                            </div>

                                            {/* Weekly Earning Card */}
                                            <div className="w-full min-h-[120px] bg-gradient-to-br from-indigo-900 to-indigo-700 rounded-2xl p-5 flex items-center gap-5 shadow-sm transition-all duration-300 hover:shadow-md hover:-translate-y-0.5">
                                                <div className="w-14 h-14 rounded-xl bg-white/20 text-white backdrop-blur-md flex justify-center items-center flex-shrink-0">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" className="bi bi-graph-up-arrow" viewBox="0 0 16 16">
                                                        <path fillRule="evenodd" d="M0 0h1v15h15v1H0zm10 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V4.707L10.354 8.354a.5.5 0 0 1-.708 0L8 6.707 4.854 9.854a.5.5 0 1 1-.708-.708l3.5-3.5a.5.5 0 0 1 .708 0L10 7.293l4.354-4.353V5.5a.5.5 0 0 1-1 0z" />
                                                    </svg>
                                                </div>
                                                <div>
                                                    <p className="text-sm text-indigo-100 font-medium tracking-wide">Weekly Earning</p>
                                                    <span className="text-2xl font-extrabold text-white mt-1 block">₹{get_wallet_details?.weakly_earn}</span>
                                                </div>
                                            </div>

                                            {/* Monthly Earning Card */}
                                            <div className="w-full min-h-[120px] bg-gradient-to-br from-teal-900 to-teal-700 rounded-2xl p-5 flex items-center gap-5 shadow-sm transition-all duration-300 hover:shadow-md hover:-translate-y-0.5">
                                                <div className="w-14 h-14 rounded-xl bg-white/20 text-white backdrop-blur-md flex justify-center items-center flex-shrink-0">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" className="bi bi-calendar-check-fill" viewBox="0 0 16 16">
                                                        <path d="M4 .5a.5.5 0 0 0-1 0V1H2a2 2 0 0 0-2 2v1h16V3a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-1 0V1H4zm5.402 9.746c.082-.166.022-.372-.144-.454l-1.402-.7A2 2 0 0 0 8 9.5a2.5 2.5 0 0 0-2.5 2.5v.5h5v-.5a2.5 2.5 0 0 0-1.098-1.754zM16 14V5H0v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2zm-6.664-1.21-1.767-1.01a.5.5 0 0 1-.25-.433V9.5a.5.5 0 0 1 1 0v1.433l1.267.724a.5.5 0 0 1-.5.867z" />
                                                    </svg>
                                                </div>
                                                <div>
                                                    <p className="text-sm text-teal-100 font-medium tracking-wide">Monthly Earning</p>
                                                    <span className="text-2xl font-extrabold text-white mt-1 block">₹{get_wallet_details?.monthly_earn}</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="mt-8">
                                            <h4 className="text-lg font-semibold text-gray-800 pb-4">Withdrawal Records</h4>
                                            <div className="overflow-x-auto w-full border border-gray-100 rounded-2xl shadow-sm">
                                                <table className="w-full text-left border-collapse min-w-[700px]">
                                                    <thead>
                                                        <tr className="bg-gray-50/75 border-b border-gray-100">
                                                            <th className="py-4 px-6 text-xs font-semibold text-gray-500 uppercase tracking-wider">S.No</th>
                                                            <th className="py-4 px-6 text-xs font-semibold text-gray-500 uppercase tracking-wider">Description</th>
                                                            <th className="py-4 px-6 text-xs font-semibold text-gray-500 uppercase tracking-wider">Date</th>
                                                            <th className="py-4 px-6 text-xs font-semibold text-gray-500 uppercase tracking-wider">Withdrawal Status</th>
                                                            <th className="py-4 px-6 text-xs font-semibold text-gray-500 uppercase tracking-wider">Amount</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody className="divide-y divide-gray-100">
                                                        {currentProduct?.length > 0 ? (
                                                            currentProduct?.map((get_wallet_result, index) => {
                                                                const status = get_wallet_result?.place || "Pending";
                                                                const lowerStatus = status.toLowerCase();
                                                                let statusClass = "text-amber-700 bg-amber-50";
                                                                if (lowerStatus.includes("approved") || lowerStatus.includes("success") || lowerStatus.includes("done")) {
                                                                    statusClass = "text-emerald-700 bg-emerald-50";
                                                                } else if (lowerStatus.includes("cancel") || lowerStatus.includes("reject") || lowerStatus.includes("fail")) {
                                                                    statusClass = "text-rose-700 bg-rose-50";
                                                                }
                                                                return (
                                                                    <tr key={index} className="hover:bg-gray-50/50 transition-colors">
                                                                        <td className="py-4 px-6 text-sm text-gray-600 font-medium">{startIndex + index + 1}</td>
                                                                        <td className="py-4 px-6 text-sm text-gray-800 font-semibold">{get_wallet_result?.description || "N/A"}</td>
                                                                        <td className="py-4 px-6 text-sm text-gray-500">{formatDate(get_wallet_result?.created_at)}</td>
                                                                        <td className="py-4 px-6 text-sm">
                                                                            <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold ${statusClass}`}>
                                                                                {status}
                                                                            </span>
                                                                        </td>
                                                                        <td className="py-4 px-6 text-sm text-[#9F2225] font-semibold">
                                                                            ₹{get_wallet_result?.req_amount}
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            })
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="5" className="py-8 text-center text-gray-400 text-sm">
                                                                    <div className="flex flex-col items-center justify-center gap-2">
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" className="bi bi-wallet2 text-gray-300" viewBox="0 0 16 16">
                                                                            <path d="M12.136.326A1.5 1.5 0 0 1 14 1.78V3h.5A1.5 1.5 0 0 1 16 4.5v9a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 13.5v-9a1.5 1.5 0 0 1 1.43-1.493L12.136.326zM5.562 3H13V1.78a.5.5 0 0 0-.621-.484zM1.5 4a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5z" />
                                                                        </svg>
                                                                        No Withdrawal History Found
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>

                                            {/* Pagination Start */}
                                            <div className="flex flex-col sm:flex-row justify-between items-center gap-4 pt-6 border-t border-gray-100 mt-6">
                                                <span className="text-sm text-gray-500 font-medium">
                                                    Showing {get_wallet_details?.withdraw_history?.length > 0 ? startIndex + 1 : 0}-{Math.min(startIndex + productsPerPage, get_wallet_details?.withdraw_history?.length)} of {get_wallet_details?.withdraw_history?.length} Records
                                                </span>
                                                <ul className="flex items-center gap-1.5 list-none pl-0 m-0">
                                                    {currentPage > 1 && (
                                                        <li>
                                                            <button
                                                                onClick={handlePrev}
                                                                className="inline-flex items-center justify-center px-3 py-1.5 border border-gray-200 text-gray-600 bg-white hover:bg-gray-50 text-sm font-semibold rounded-lg transition-all duration-200 shadow-sm"
                                                            >
                                                                Prev
                                                            </button>
                                                        </li>
                                                    )}
                                                    {[...Array(totalPages).keys()].map((page) => (
                                                        <li key={page}>
                                                            <button
                                                                onClick={() => handlePageChange(page + 1)}
                                                                className={`inline-flex items-center justify-center w-8 h-8 text-sm font-semibold rounded-lg transition-all duration-200 ${currentPage === page + 1
                                                                    ? 'bg-[#9F2225] text-white shadow-sm'
                                                                    : 'border border-gray-200 text-gray-600 bg-white hover:bg-gray-50'
                                                                    }`}
                                                            >
                                                                {page + 1}
                                                            </button>
                                                        </li>
                                                    ))}
                                                    {currentPage < totalPages && (
                                                        <li>
                                                            <button
                                                                onClick={handleNext}
                                                                className="inline-flex items-center justify-center px-3 py-1.5 border border-gray-200 text-gray-600 bg-white hover:bg-gray-50 text-sm font-semibold rounded-lg transition-all duration-200 shadow-sm"
                                                            >
                                                                Next
                                                            </button>
                                                        </li>
                                                    )}
                                                </ul>
                                            </div>

                                            {/* Withdrawal Modal */}
                                            {is_withdrawal && (
                                                <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex justify-center items-center z-50 p-4">
                                                    <div className="bg-white p-6 sm:p-8 rounded-2xl shadow-xl w-full max-w-md transform transition-all duration-300 ease-out">
                                                        {/* Modal Header */}
                                                        <div className="flex items-center justify-between border-b border-gray-100 pb-4 mb-4">
                                                            <h3 className="text-lg font-bold text-gray-800">Request Withdrawal</h3>
                                                            <button onClick={handle_cancel_withdrawal} className="text-gray-400 hover:text-gray-600 transition-colors">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-x-lg" viewBox="0 0 16 16">
                                                                    <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                                                                </svg>
                                                            </button>
                                                        </div>

                                                        {/* Modal Content */}
                                                        <div className="flex items-center gap-2 bg-gray-50 border border-gray-100 p-3 rounded-xl mb-4">
                                                            <span className="text-sm font-semibold text-gray-500">Available Balance:</span>
                                                            <span className="text-base font-bold text-gray-800">₹{get_wallet_details?.total_amount}</span>
                                                        </div>

                                                        <div>
                                                            <form className="flex flex-col gap-3">
                                                                <label className={`flex items-start gap-3 p-3.5 border rounded-xl cursor-pointer transition-all duration-200 ${withdrawal_type === 'full'
                                                                    ? 'border-[#9F2225] bg-red-50/20'
                                                                    : 'border-gray-200 hover:bg-gray-50/50'
                                                                    }`}>
                                                                    <input
                                                                        type="radio"
                                                                        name="withdrawal_type"
                                                                        value="full"
                                                                        className="mt-1 w-4 h-4 text-[#9F2225] focus:ring-[#9F2225]"
                                                                        onChange={(e) => {
                                                                            setError({})
                                                                            set_Is_Withdrawal_Type(e.target.value)
                                                                        }}
                                                                        checked={withdrawal_type === "full"}
                                                                    />
                                                                    <div>
                                                                        <span className="font-semibold text-sm text-gray-800 block">Full Withdrawal</span>
                                                                        <span className="text-xs text-gray-500">Withdraw your entire balance of ₹{get_wallet_details?.total_amount}</span>
                                                                    </div>
                                                                </label>

                                                                <label className={`flex items-start gap-3 p-3.5 border rounded-xl cursor-pointer transition-all duration-200 ${withdrawal_type === 'partial'
                                                                    ? 'border-[#9F2225] bg-red-50/20'
                                                                    : 'border-gray-200 hover:bg-gray-50/50'
                                                                    }`}>
                                                                    <input
                                                                        type="radio"
                                                                        name="withdrawal_type"
                                                                        value="partial"
                                                                        className="mt-1 w-4 h-4 text-[#9F2225] focus:ring-[#9F2225]"
                                                                        onChange={(e) => {
                                                                            setError({})
                                                                            set_Is_Withdrawal_Type(e.target.value)
                                                                        }}
                                                                        checked={withdrawal_type === "partial"}
                                                                    />
                                                                    <div className="w-full">
                                                                        <span className="font-semibold text-sm text-gray-800 block">Partial Withdrawal</span>
                                                                        <span className="text-xs text-gray-500 block mb-2">Withdraw a specific custom amount</span>
                                                                        {withdrawal_type === "partial" && (
                                                                            <div className="mt-2 w-full">
                                                                                <input
                                                                                    type="number"
                                                                                    className="w-full px-4 py-2 bg-white border border-gray-200 rounded-lg text-gray-700 text-sm outline-none focus:ring-2 focus:ring-[#9F2225]/20 focus:border-[#9F2225] transition-all no-spinner"
                                                                                    name="partial_amount"
                                                                                    value={partial_amount}
                                                                                    placeholder="Enter amount (₹100 or more)"
                                                                                    onChange={handlePartialAmountChange}
                                                                                />
                                                                                {error.partial_amount && (
                                                                                    <p className="text-red-500 text-xs mt-1 font-medium">{error.partial_amount}</p>
                                                                                )}
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </label>

                                                                {error.message && (
                                                                    <p className="text-red-500 text-sm mt-1 text-center font-medium bg-red-50 py-2 rounded-lg">{error.message}</p>
                                                                )}
                                                            </form>
                                                        </div>

                                                        <div className="flex flex-col sm:flex-row justify-end gap-3 mt-6 pt-4 border-t border-gray-100">
                                                            <button
                                                                onClick={handle_cancel_withdrawal}
                                                                className="w-full sm:w-auto px-4 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 font-semibold rounded-lg text-sm transition-all duration-200"
                                                            >
                                                                Close
                                                            </button>
                                                            <button
                                                                type="button"
                                                                onClick={() => handle_withdrawal_request()}
                                                                className="w-full sm:w-auto px-4 py-2 bg-[#9F2225] hover:bg-[#851c1e] text-white font-semibold rounded-lg text-sm shadow-sm transition-all duration-200"
                                                            >
                                                                Withdrawal
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            {/* Confirmation Modal */}
                                            {confirmation_popup && (
                                                <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex justify-center items-center z-50 p-4">
                                                    <div className="bg-white p-6 sm:p-8 rounded-2xl shadow-xl w-full max-w-md transform transition-all duration-300 ease-out">
                                                        <div className="flex items-center gap-3 text-red-600 mb-3">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-exclamation-triangle-fill" viewBox="0 0 16 16">
                                                                <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5m.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2" />
                                                            </svg>
                                                            <h3 className="text-lg font-bold text-gray-800">Cancel Withdrawal Request?</h3>
                                                        </div>
                                                        <p className="text-sm text-gray-500 leading-relaxed mb-6">
                                                            Are you sure you want to cancel this withdrawal process? The funds will remain in your wallet balance.
                                                        </p>
                                                        <div className="flex flex-col sm:flex-row justify-end gap-3 pt-4 border-t border-gray-100">
                                                            <button
                                                                onClick={handle_Keep_withdrawal}
                                                                className="w-full sm:w-auto px-4 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 font-semibold rounded-lg text-sm transition-all duration-200"
                                                            >
                                                                Keep Withdrawal
                                                            </button>
                                                            <button
                                                                type="button"
                                                                onClick={() => handle_Cancel_withdrawal_request()}
                                                                className="w-full sm:w-auto px-4 py-2 bg-[#9F2225] hover:bg-[#851c1e] text-white font-semibold rounded-lg text-sm shadow-sm transition-all duration-200"
                                                            >
                                                                Cancel Withdrawal
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
            {/*  */}
            <Astrologer_Footer />
        </div>
    )
}

export default Withdrawal_History